<template>
<v-card class="ma-0 pa-0" elevation="3" v-if="item.active">
    <v-row class="px-2 my-3" align="center" style="cursor: move">
        <v-col class="text-center" cols="2" sm="1">
            <v-icon>drag_handle</v-icon>
        </v-col>

        <v-col class="display-1 text-center" cols="2" sm="1">
            <v-btn icon small @click="$emit('up', item)">
                <v-icon dense size="36">arrow_drop_up</v-icon>
            </v-btn>
            <div>{{ item.index }}</div>
            <v-btn icon small @click="$emit('down', item)">
                <v-icon dense size="36">arrow_drop_down</v-icon>
            </v-btn>
        </v-col>

        <v-col class="display-1 text-center" @click="changeSort(item)" style="cursor: pointer" cols="6" sm="2">
            <div style="color: #3498db; font-weight: bold">{{ item.name }}</div>
            <div class="mt-2">
                <span>{{ sortName }}</span>
                <v-icon> {{ sortIcon }}</v-icon>
            </div>
        </v-col>

        <v-col class="text-center" cols="2" sm="1">
            <v-icon style="cursor: pointer" @click="$emit('remove', item)">delete</v-icon>
        </v-col>

        <v-col cols="12" sm="7">
            <vue-slider v-model="item.value" :min="item.min" :max="item.max" :interval="0.1" drag-on-click tooltip="always" :enable-cross="false" :tooltip-formatter="item.formatter" @error="handleError($event, item)" />
            <v-row>
                <v-text-field class="pa-2 pb-0" v-model="item.value[0]" outlined dense hide-details @input="inputChagned(item)" @mouseover="$emit('disabledrag')" @mouseleave="$emit('enabledrag')" />
                <v-text-field class="pa-2 pb-0" v-model="item.value[1]" outlined dense hide-details @input="inputChagned(item)" @mouseover="$emit('disabledrag')" @mouseleave="$emit('enabledrag')" />
            </v-row>
            <div class="text-center" style="color: red">{{ item.message }}</div>
        </v-col>
    </v-row>
</v-card>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    name: 'condition-item',
    components: {
        VueSlider
    },
    props: [
        'item'
    ],
    data() {
        return {}
    },
    computed: {
        sortName() {
            return this.item.order == "ASC" ? "오름차순" : "내림차순"
        },
        sortIcon() {
            return this.item.order == "ASC" ? "arrow_downward" : "arrow_upward"
        }
    },
    async mounted() {},
    methods: {
        handleError(type, item) {
            let msg = ''
            switch (type) {
                case 1: // VALUE
                    msg = "올바르지 않은 값입니다"
                    break
                case 3: // MIN
                    msg = "최소값보다 작은 값입니다"
                    break
                case 4: // MAX
                    msg = "최대값보다 큰 값입니다"
                    break
            }

            item.message = msg
        },
        inputChagned(item) {
            item.message = ""
        },
        changeSort() {
            this.item.order = this.item.order == "ASC" ? "DESC" : "ASC"
        },
    }
}
</script>

<style>
.item-head {
    font-size: 11px;
}

.discuss-title:hover {
    cursor: pointer;
    text-decoration: underline;
}
</style>
